<app-loader></app-loader>
<mat-dialog-actions class="justify-content-between">
    <h3>{{ (readOnly ? 'LABEL.VIEW_LABEL' : (isUpdateMode ? 'LABEL.UPDATE_LABEL' : 'LABEL.ADD_LABEL')) | translate }} {{
        'BUTTON.BTN_OPERATION_SUMMARY' |
        translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="operationForm">
        <div class="row m-t-10">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.OPERATION_DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="IPDpicker" formControlName="operationDate" [min]="minDate" required
                        [max]="maxDate" placeholder="DD/MM/YYYY" [readonly]="readOnly">
                    <mat-datepicker-toggle matIconSuffix [for]="IPDpicker"
                        [disabled]="readOnly"></mat-datepicker-toggle>
                    <mat-datepicker #IPDpicker [color]="'primary'"></mat-datepicker>
                    <mat-error *ngIf="operationForm.get('operationDate')?.hasError('required')">
                        {{ 'REQUIRED.SELECT_DATE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.OPERATION_TIME' | translate }}</mat-label>
                    <input matInput type="time" formControlName="operationTime" [readonly]="readOnly">
                    <mat-error *ngIf="operationForm.get('operationTime')?.hasError('required')">
                        {{ 'REQUIRED.SELECT_TIME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ASSITANT_DOCTOR' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.ASSITANT_DOCTOR' | translate }}"
                        [matAutocomplete]="autoAssistantDoctor" [formControl]="assistantDoctorCtrl"
                        #assistantDoctorInput [readonly]="readOnly" />
                    <mat-autocomplete #autoAssistantDoctor="matAutocomplete" [displayWith]="displayAssistantDoctor"
                        (optionSelected)="onAssistantDoctorSelected($event.option.value)">
                        <mat-option *appHasRole="ROLE_GROUPS.AdminOnly; when: showAddOptionForAssistantDoctor" class="text-primary"
                            (mousedown)="$event.preventDefault(); addAssistantDoctor(assistantDoctorInput.value)">
                            <strong>{{ 'LABEL.ADD_LABEL' | translate }} "{{ assistantDoctorCtrl.value }}"</strong>
                        </mat-option>
                        <mat-option *ngFor="let doctor of filteredAssistantDoctors$ | async" [value]="doctor">
                            {{ doctor.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ANESTHETIST' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.ANESTHETIST' | translate }}"
                        [matAutocomplete]="autoAnesthetist" [formControl]="anesthetistCtrl" #anesthetistInput
                        [readonly]="readOnly" />
                    <mat-autocomplete #autoAnesthetist="matAutocomplete" [displayWith]="displayAnesthetist"
                        (optionSelected)="onAnesthetistSelected($event.option.value)">
                        <mat-option *appHasRole="ROLE_GROUPS.Clinical; when: showAddOptionForAnesthetist && !readOnly" class="text-primary"
                            (mousedown)="$event.preventDefault(); addAnesthetist(anesthetistInput.value)">
                            <strong>Add "{{ anesthetistCtrl.value }}"</strong>
                        </mat-option>
                        <mat-option *ngFor="let anesthetist of filteredAnesthetists$ | async" [value]="anesthetist">
                            {{ anesthetist.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ANESTHESIA' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.ANESTHESIA' | translate }}" cols="5" rows="3"
                        formControlName="anesthesia" [readonly]="readOnly"></textarea>
                    <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup(TemplateType.Anesthesia)"
                        [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="!readOnly">
                        <i-tabler name="template" class="icon-18"></i-tabler>
                    </a>
                    <mat-error *ngIf="operationForm.get('anesthesia')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

         <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.HISTORY_NOTES' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.HISTORY_NOTES' | translate }}" cols="5" rows="3"
                        formControlName="historyNotes" [readonly]="readOnly"></textarea>
                    <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup(TemplateType.HistoryNotes)"
                        [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="!readOnly">
                        <i-tabler name="template" class="icon-18"></i-tabler>
                    </a>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.NATURE_OF_TREATMENT' | translate }}</mat-label>
                    <input type="text" matInput placeholder="Search Nature of Treatment"
                        [matAutocomplete]="autoNatureOfTreatment" [formControl]="natureOfTreatmentCtrl"
                        #natureOfTreatmentInput [readonly]="readOnly" />
                    <mat-autocomplete #autoNatureOfTreatment="matAutocomplete" [displayWith]="displayNatureOfTreatment"
                        (optionSelected)="onNatureOfTreatmentSelected($event.option.value)">
                        <mat-option *appHasRole="ROLE_GROUPS.Clinical; when: showAddOptionForNatureOfTreatment && !readOnly" class="text-primary"
                            (mousedown)="$event.preventDefault(); addNatureOfTreatment(natureOfTreatmentInput.value)">
                            <strong>Add "{{ natureOfTreatmentCtrl.value }}"</strong>
                        </mat-option>
                        <mat-option *ngFor="let item of filteredNatureOfTreatment$ | async" [value]="item">
                            {{ item.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.TREATMENT_GIVEN' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.TREATMENT_GIVEN' | translate }}" cols="5" rows="3"
                        formControlName="treatmentGiven" [readonly]="readOnly"></textarea>
                    <a mat-icon-button matSuffix class="tmpl-suffix" (click)="openTemplatePopup(TemplateType.TreatmentGiven)"
                        [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="!readOnly">
                        <i-tabler name="template" class="icon-16"></i-tabler>
                    </a>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.OPERATIVE_NOTE' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.OPERATIVE_NOTE' | translate }}" cols="5" rows="3"
                        formControlName="operationNotes" [readonly]="readOnly"></textarea>
                    <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup(TemplateType.OperativeNote)"
                        [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="!readOnly">
                        <i-tabler name="template" class="icon-18"></i-tabler>
                    </a>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.INVESTIGATION' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.INVESTIGATION' | translate }}" cols="5" rows="3"
                        formControlName="investigation" [readonly]="readOnly"></textarea>
                    <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openSuggestedInvestigationPopup()"
                        [matTooltip]="'LABEL.SELECT_SUGGESTED_INVESTIGATION' | translate" *ngIf="!readOnly">
                        <i-tabler name="list-check" class="icon-18"></i-tabler>
                    </a>
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' |
                translate}}</button>
            <button *ngIf="!readOnly && !isUpdateMode" mat-flat-button color="primary" class=" m-l-4"
                (click)="onSaveOperationSummary()">{{
                'BUTTON.BTN_SAVE' | translate }}</button>
            <button *ngIf="!readOnly && isUpdateMode" mat-flat-button color="primary" class=" m-l-4"
                (click)="onUpdateOperationSummary()">{{
                'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>